import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import ChemicalSelectionFields from "../../components/ChemicalSelectionFields";
import UtilityCostFields from "../../components/UtilityCosts/UtilityCostFields";

import {
  CURRENCY_SYMBOLS,
  DEFAULT_CURRENCY_SYMBOL,
} from "../../constants/currencies.constants";

import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";

import "./index.scss";

const CostInformation = (props) => {
  const { t } = useTranslation();
  const { disabled = false } = props;

  const { trainUtilityCosts, trainChemicalSelection, currency, volume, mass } =
    useSelector((state) => state);

  const costValues = useMemo(
    () => ({
      priceOfWater: trainUtilityCosts?.water_price || "",
      costOfElectricity: trainUtilityCosts?.energy_price || "",
      costOfDowntime: trainUtilityCosts?.downtime_cost || "",
    }),
    [trainUtilityCosts],
  );

  return (
    <div className="ro-card-wrapper position-relative cost-information-card">
      <div className="ro-card-header">
        <div className="info-section">
          <div className="teal-heading ">
            {t("costInformationStrings.constInformation")}
          </div>
          {!disabled && (
            <IconWithTooltip label={t("helpInformation.costInformationHelp")} />
          )}
        </div>
      </div>
      <div className="cost-information-sections">
        <div className="cost-information-section">
          <div className="cost-information-section-header">
            {t("costInformationStrings.chemicalCosts")}
          </div>
          <ChemicalSelectionFields
            selectedChemicals={trainChemicalSelection}
            currencySymbol={
              currency ? CURRENCY_SYMBOLS[currency] : DEFAULT_CURRENCY_SYMBOL
            }
            mass={mass}
            disabled={disabled}
            containerClassName="cost-info-chemical-costs"
          />
        </div>

        <div className="cost-information-section">
          <div className="cost-information-section-header">
            {t("costInformationStrings.utilityCosts")}
          </div>
          <UtilityCostFields
            values={costValues}
            currency={currency}
            volume={volume}
            disabled={disabled}
            containerClassName="cost-info-utility-costs"
          />
        </div>
      </div>
    </div>
  );
};

export default CostInformation;
